import Vue from 'vue';
import Vuex from 'vuex';

import moduleWindow from './window/index';

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        window: moduleWindow,
    },
    strict: true,
});

export default store;
